<template>
  <div :class="`flex-1 flex row ${loading ? 'animate-blinking' : ''}`">
    <div v-for="(content, index) in data" :key="`column-${index}-${id}`" class="flex-1">
      <template v-for="item in content" :key="`${item.type}-${index}-${item.value}`">
        <p v-if="item.type === 'Text'">{{ item.value }}</p>
        <p v-else-if="item.type === 'TextBold'" class="bold">
          <router-link v-if="item.link" :to="item.link">{{ item.value }}</router-link>
          <span v-else>{{ item.value }}</span>
        </p>
        <p v-else-if="item.type === 'ScheduledAt'" class="bold">{{ item.value }}</p>
        <p v-else-if="item.type === 'TextBoldBlue'" class="nsil">
          <router-link v-if="item.link" :to="item.link">{{ item.value }}</router-link>
          <span v-else>{{ item.value }}</span>
        </p>
        <div v-else-if="item.type === 'Attribute'" class="relative-container">
          <AttributionVisite 
            :technicalManager="item.value"
            :propertyId="id"
            :propertyTeams="propertyTeams"
            :onAttribute="onAttribute"
            :hasUnsyncedData="hasUnsyncedData"
          />
        </div>
        <div v-else-if="item.type === 'Planify'" class="relative-container">
          <DatePickerButton
            :id="`planify-${id}`"
            :value="item.value || ''"
            @change="(date) => onPlanify(date)"
            @reset="onResetPlanification"
            :hasUnsyncedData="hasUnsyncedData"
          >
            À planifier
          </DatePickerButton>
        </div>
        <div v-else-if="item.type === 'Planified'" class="relative-container">
          <DatePickerButton
            :id="`planified-${id}`"
            :value="item.value || ''"
            @change="(date) => onPlanify(date)"
            @reset="onResetPlanification"
            :hasUnsyncedData="hasUnsyncedData"
          >
            Planifiée le
          </DatePickerButton>
        </div>
        <div v-else-if="item.type === 'TextLoading'" :class="`loading-placeholder ${item.value} animate-pulse`">
          <div class="loading-shimmer"></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import AttributionVisite from './AttributionVisite.vue'
import DatePickerButton from '../Widget/DatePickerButton.vue'

export default {
  name: 'ListLine',
  components: {
    AttributionVisite,
    DatePickerButton
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    // Équipes de la propriété pour la logique de délégation
    propertyTeams: {
      type: Array,
      default: () => []
    },
    // Indicateur si la propriété a des données en attente de synchronisation
    hasUnsyncedData: {
      type: Boolean,
      default: false
    },
    onAttribute: {
      type: Function,
      default: () => () => () => null
    },
    onPlanify: {
      type: Function,
      default: () => () => null
    },
    onResetPlanification: {
      type: Function,
      default: () => () => null
    },
    onCheck: {
      type: Function,
      default: () => () => () => null
    }
  },
  methods: {
    getDelegationTextFromColumn(content) {
      // Chercher un élément de type 'Text' qui contient "Délégation"
      const delegationItem = content.find(item => 
        item.type === 'Text' && 
        item.value && 
        item.value.includes('Délégation')
      )
      return delegationItem ? delegationItem.value : ''
    }
  }
}
</script>

<style scoped>
@import './ListLine.scss';
</style>
